import { map } from 'lodash';
import React from 'react';
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';
import { PIE_CHART_COLORS } from '../../../common/constants';

const colors = PIE_CHART_COLORS;

// Custom legend content renderer for responsive layout
const renderCustomLegend = (props) => {
  const { payload } = props;

  if (!payload?.length) return null;

  return (
    <div className="chart-legend-container">
      <div className="chart-legend-wrapper">
        {payload?.map((entry, index) => {
          const colorIndex = index % colors?.length;
          const color = entry?.color || colors[colorIndex];
          return (
            <div
              key={`legend-${entry?.value}-${entry?.color}`}
              className="chart-legend-item"
              style={{ '--legend-color': color }} // using chart css directly
            >
              <span className="chart-legend-color" />
              <span className="chart-legend-text">{entry?.value}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const ChartRenderer = ({ resultSet }) => {
  const data = map(resultSet, (item) => {
    return {
      category: item['ProjectEqcType.name'],
      'EqcStageHistory.count': Number(item['EqcStageHistory.count']),
    };
  });

  // Prepare data with colors for proper legend rendering
  const dataWithColors = data?.map((item, index) => ({
    ...item,
    color: colors[index % colors?.length],
  }));

  // Use fixed height for consistent spacing
  const chartHeight = 480;

  return (
    <div className="chart-container">
      <ResponsiveContainer width="100%" height={chartHeight}>
        <PieChart margin={{ top: 20, right: 20, left: 20, bottom: 120 }}>
          <Pie
            isAnimationActive={false}
            data={dataWithColors}
            nameKey="category"
            dataKey="EqcStageHistory.count"
            fill="#8884d8"
            cx="50%"
            cy="45%"
            outerRadius={160} // Increased from 140 to 160 (14% increase)
          >
            {dataWithColors?.map((e, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Cell key={index} fill={colors[index % colors.length]} />
            ))}
          </Pie>
          <Legend
            content={renderCustomLegend}
            verticalAlign="bottom"
            align="center"
            className="recharts-legend-wrapper"
          />
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ChartRenderer;
